import { BottomBarItem } from '@ui/bottom-bar';
import { Home2, Profile, Shop } from 'iconsax-react';
import { Icon } from '@iconify/react';
import { useKeyboardVisibility } from '@shared/hooks/use-keyboard-visibility.ts';
import { useLocation } from 'react-router-dom';

export const MobileBottomBar = () => {
  const isVisible = useKeyboardVisibility('visibility');
  const { pathname } = useLocation();

  return (
    <div
      style={{ bottom: isVisible ? -68 : 0 }}
      className="drop-shadow-[0_0_12px_#34578C26] bg-white fixed inset-x-0 bottom-0 h-[68px] flex flex-row items-center justify-around lg:hidden px-2 z-20"
    >
      <BottomBarItem
        isActive={['/'].includes(pathname)}
        icon={(isActive) => (
          <Home2 size="24" color={isActive ? '#006FEE' : '#9CA5AC'} />
        )}
        text="Главная"
        href="/"
      />

      <BottomBarItem
        isActive={['/category'].includes(pathname)}
        icon={(isActive) => (
          <Icon
            width={24}
            height={24}
            icon="solar:widget-6-linear"
            color={isActive ? '#006FEE' : '#9CA5AC'}
          />
        )}
        text="Каталог"
        href="/category"
      />

      <BottomBarItem
        isActive={['/cart'].includes(pathname)}
        icon={(isActive) => (
          <Icon
            width={24}
            height={24}
            icon="solar:bag-4-outline"
            color={isActive ? '#006FEE' : '#9CA5AC'}
          />
        )}
        text="Корзина"
        href="/cart"
      />

      <BottomBarItem
        isActive={['/store'].includes(pathname)}
        icon={(isActive) => (
          <Shop size="24" color={isActive ? '#006FEE' : '#9CA5AC'} />
        )}
        text="Аптеки"
        href="/store"
      />

      <BottomBarItem
        isActive={['/profile'].includes(pathname)}
        icon={(isActive) => (
          <Profile size="24" color={isActive ? '#006FEE' : '#9CA5AC'} />
        )}
        text="Профиль"
        href="/profile"
      />
    </div>
  );
};
